/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      setTimeout(() => {
        this.buttons = Array.from(this.querySelectorAll('button'));
        this.target = this.dataset.target;

        // === 尋找 .section-header ===
        let headerElement = null;

        const headerId = this.dataset.headerId;
        if (headerId) {
          headerElement = document.getElementById(headerId);
          console.log('通過 data-header-id 查找結果：', headerElement ? '找到' : '未找到');
        }

        if (!headerElement) {
          headerElement = this.closest('.collection-tabs.section-spacing')?.querySelector('.section-header')
            || this.parentElement?.querySelector('.section-header')
            || this.previousElementSibling?.querySelector('.section-header')
            || document.querySelector('.collection-tabs.section-spacing .section-header');

          console.log('fallback 查找 .section-header 結果：', headerElement ? '找到' : '未找到');
        }

        this.links = headerElement ? headerElement.querySelectorAll('.linked-to-tab') : [];

        // ───────────── 重要：初始化時記錄每個 handle 的原始 href ─────────────
        this.hrefMap = {};

        this.links.forEach(link => {
          const handle = link.dataset.collectionHandle;
          if (handle) {
            const originalHref = link.getAttribute('href');
            this.hrefMap[handle] = originalHref;
            console.log(`[初始化] 記錄 → ${handle} : ${originalHref}`);
          }
        });

        console.log('CollectionTabs 初始化完成');
        console.log('找到的 links 數量：', this.links.length);
        console.log('hrefMap 內容：', this.hrefMap);

        if (this.links.length === 0) {
          console.warn('警告：未找到任何 .linked-to-tab 元素');
        }

        // 按鈕點擊事件
        this.buttons.forEach(button => {
          button.addEventListener('click', (event) => {
            const handle = button.dataset.collection;

            console.log(`[點擊] tab: ${button.textContent.trim()} | handle: ${handle}`);

            // 切換 active 樣式
            this.buttons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');

            // ───────────── 更新 View All 連結 ─────────────
            if (handle && this.links.length > 0) {
              const targetHref = this.hrefMap[handle];

              if (targetHref) {
                console.log(`[更新] 將所有 View All 設為：${targetHref}`);

                this.links.forEach(link => {
                  link.setAttribute('href', targetHref);
                });
              } else {
                console.warn(`[警告] hrefMap 中找不到 handle: ${handle}`);
                console.log('當前 hrefMap：', this.hrefMap);
              }
            } else {
              console.warn('[警告] 缺少 handle 或 links 為空');
            }

            // 切換產品內容
            if (handle) {
              this.toggleCollection(handle);
            }

            event.preventDefault();
          });
        });

        // ───────────── 新增：處理視窗大小變化時的 Flickity 重算 ─────────────
        this.setupResizeHandler();

      }, 10);

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.buttons.indexOf(event.target);
          if (index !== -1) {
            this.buttons[index].dispatchEvent(new Event('click'));
          }
        });
      }
    }

    // 新增方法：設定 resize 監聽（使用 debounce 避免過度觸發）
    setupResizeHandler() {
      const slider = document.getElementById(this.target);
      if (!slider) return;

      const flkty = Flickity.data(slider);
      if (!flkty) return;

      // debounce 函式
      const debounce = (fn, delay) => {
        let timer = null;
        return (...args) => {
          if (timer) clearTimeout(timer);
          timer = setTimeout(() => {
            fn.apply(this, args);
          }, delay);
        };
      };

      const refreshCarousel = debounce(() => {
        if (flkty) {
          console.log('[resize] Flickity 正在重新計算尺寸');
          flkty.resize();          // 重新計算容器寬度
          flkty.reloadCells();     // 重新計算所有 cell 的尺寸與位置
          // 保持目前選中的位置，避免跳到第一張
          const currentIndex = flkty.selectedIndex;
          if (currentIndex >= 0) {
            flkty.select(currentIndex, false, true);
          }
        }
      }, 180);  // 180ms 延遲，平衡流暢度與效能

      window.addEventListener('resize', refreshCarousel);

      // 記錄以便未來移除（雖然大多數情況不需要）
      this._resizeHandler = refreshCarousel;

      // 初次載入延遲一點也執行一次（確保初始比例正確）
      setTimeout(refreshCarousel, 400);
    }

    // 可選：元件移除時清除監聽（避免記憶體洩漏）
    disconnectedCallback() {
      if (this._resizeHandler) {
        window.removeEventListener('resize', this._resizeHandler);
      }
    }

    toggleCollection(handle) {
      const slider = document.getElementById(this.target);
      if (!slider) return;

      const products = slider.querySelectorAll(`.columns:not([data-collection="${handle}"])`);
      const active_products = slider.querySelectorAll(`[data-collection="${handle}"]`);
      const flkty = Flickity.data(slider);

      if (!flkty) return;

      products.forEach(el => {
        el.classList.remove('carousel__slide');
        slider.append(el);
      });

      active_products.forEach(el => {
        el.classList.add('carousel__slide');
      });

      flkty.insert(active_products);
      flkty.reloadCells();
      flkty.select(0, false, true);
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
}